var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack612({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.83,3.91H8A8,8,0,0,1,9.37,4a2.15,2.15,0,0,1,.83.32,2.12,2.12,0,0,1,.6.66,1.78,1.78,0,0,1,.24.92A1.88,1.88,0,0,1,9.94,7.6a2.1,2.1,0,0,1,1.1.71,1.91,1.91,0,0,1,.39,1.19,2.25,2.25,0,0,1-.25,1,2.19,2.19,0,0,1-.68.82,2.35,2.35,0,0,1-1.07.37c-.26,0-.9,0-1.92,0H4.83ZM6.42,5.22V7h1c.61,0,1,0,1.15,0a1,1,0,0,0,.64-.28.81.81,0,0,0,.24-.61.84.84,0,0,0-.21-.6.89.89,0,0,0-.59-.27c-.16,0-.62,0-1.36,0Zm0,3.13v2.11H7.9A7.51,7.51,0,0,0,9,10.41a1,1,0,0,0,.57-.32,1,1,0,0,0,.23-.67,1,1,0,0,0-.67-1,5.74,5.74,0,0,0-1.41-.11Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack612);
export default __webpack_public_path__ + "static/media/Symbolpack_6_12.e9508ea726ec4c56b65de6ddfb7e4b4a.svg";
export { ForwardRef as ReactComponent };